import { render, staticRenderFns } from "./OverviewTableReportDataPublication.vue?vue&type=template&id=47e7b1f9&"
import script from "./OverviewTableReportDataPublication.vue?vue&type=script&lang=ts&"
export * from "./OverviewTableReportDataPublication.vue?vue&type=script&lang=ts&"
import style0 from "./OverviewTableReportDataPublication.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports